export const getClientGeoLocation: any = function(options: PositionOptions) {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      resolve,
      ({ code, message }) => reject(Object.assign(new Error(message), { name: 'PositionError', code })),
      options
    );
  });
};

export enum LandingPageType {
  ULTRA_LOCAL = 'neighborhood',
  LOCAL = 'multi_city_vicinity'
}
